// Floor a computed SVG dimension (a pie radius, or a width/height/r derived from
// one) to a finite, non-negative value.
//
// The View Wheel renderer sizes every element from `svgHeightWidth` =
// min(parent.clientWidth, parent.clientHeight) - margin. During transient layout
// frames (initial mount, a container animating open) the parent can measure
// smaller than `margin`, making `svgHeightWidth` — and every radius derived from
// it — negative (e.g. svgHeightWidth = -1 -> pieInnerRadius*2 = -0.667,
// pieOutterRadius*2.5 = -1.25). SVG rejects negative width/height/r values
// ("Error: <foreignObject>/<image> attribute width: A negative value is not
// valid"), spamming the browser console.
//
// Flooring the two pie radii at their computation keeps every downstream
// <image> / <foreignObject> / <circle> dimension >= 0, so no element is ever
// asked to paint a negative size. Non-finite inputs (NaN from an unmeasured
// parent, Infinity) collapse to 0 for the same reason.
export const clampNonNegative = (value) =>
  Number.isFinite(value) ? Math.max(0, value) : 0;
